import { generatePath, useParams } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';

import { useCurrentRoutePattern, useNavigateWithSearch } from '@sternum/web/hooks';
import { appStorage } from '@sternum/web/services/appStorage';
import { trpc, TRPCReactQueryOptions } from '@sternum/web/services/trpc';
import { useAppDispatch } from '@sternum/web/store';
import { clearReduxStoreAction } from '@sternum/web/store/globalActions';

import { useSelectedClientId } from '../useSelectedClientId';

export function useSaveLastUsedClient(options?: TRPCReactQueryOptions['auth']['saveLastUsedClient']) {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const navigate = useNavigateWithSearch();
  const currentPattern = useCurrentRoutePattern();
  const pathParams = useParams();
  const currentClientId = useSelectedClientId();

  return trpc.auth.saveLastUsedClient.useMutation({
    ...options,
    async onSuccess(...args) {
      const newClientId = args[1].clientId;

      if (newClientId === currentClientId) return;

      if (currentPattern) {
        navigate(
          generatePath(currentPattern, { ...pathParams, clientId: newClientId }),
          new URLSearchParams(window.location.search),
          {
            replace: true,
          },
        );
      } else {
        console.error(`Failed to redirect to non-existing route. Current path: ${window.location.pathname}`);
      }

      queryClient.invalidateQueries();
      queryClient.clear();
      appStorage.clearClientSpecificData();
      dispatch(clearReduxStoreAction());

      options?.onSuccess?.(...args);
    },
  });
}
